import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Region } from '../../entities/region';

@Injectable({ providedIn: 'root' })
export class UserRegionRepository {
  private get table() {
    return this.db.userRegionsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Region[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Region(row));
  }

  async getById(locationId: number): Promise<Region | undefined> {
    const row = await this.table.get(locationId);
    return row ? new Region(row) : undefined;
  }

  upsert(region: Region): Promise<number> {
    return this.table.put(region);
  }

  upsertBulk(regions: Region[]): Promise<number> {
    return this.table.bulkPut(regions);
  }

  delete(locationId: number): Promise<void> {
    return this.table.delete(locationId);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}